export default __webpack_public_path__ + "static/media/icon.9b1026dd.svg";